module.exports = {
  title: `ZungTa's Blog`,
  description: `ZungTa's Blog`,
  author: `ZungTa`,
  introduction: `ZungTa입니다.`,
  siteUrl: `https://zungta.com/`, // Your blog site url
  social: {
    twitter: ``, // Your Twitter account
    github: `https://github.com/ZungTa`, // Your GitHub account
    medium: ``, // Your Medium account
    facebook: ``, // Your Facebook account
    linkedin: ``, // Your LinkedIn account
    instagram: ``, // Your Instagram account
  },
  icon: `content/assets/felog.png`, // Add your favicon
  keywords: [`blog`],
  comment: {
    disqusShortName: '', // Your disqus-short-name. check disqus.com.
    // utterances: 'JaeYeopHan/gatsby-starter-bee', // Your repository for archive comment
    utterances: '', // Your repository for archive comment
  },
  configs: {
    countOfInitialPost: 10, // Config your initial count of post
  },
  sponsor: {
    buyMeACoffeeId: '',
  },
  share: {
    facebookAppId: '', // Add facebookAppId for using facebook share feature v3.2
  },
  ga: 'GTM-5M5PML6R', // Add your google analytics tranking ID
};
